// @ts-nocheck
// /schedule/appointment/:id — no longer a page. The appointment screen is the
// customer window's Appointments tab (AppointmentRecord inside AppointmentsTab),
// so this route resolves the appointment to its customer and opens that window
// on the right tab with the visit expanded. Deep links keep working; closing the
// window returns to wherever the link came from. A visit with no customer record
// (nothing to open a window for) renders the record on its own.
import React, { useEffect, useState, Suspense, lazy } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getAppointmentDetail } from '../../api/appointmentsApi';
import AppointmentRecord from './AppointmentRecord';
import './AppointmentDetail.css';

const CustomerPopup = lazy(() => import('../Profile/CustomerPopup'));

export default function AppointmentDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const boardStartLabel = location.state?.boardStartLabel || null;
  const [customer, setCustomer] = useState(undefined); // undefined = resolving, null = none

  useEffect(() => {
    let alive = true;
    getAppointmentDetail(id)
      .then((r) => { if (alive) setCustomer(r.data?.customer?.id ? r.data.customer : null); })
      .catch(() => { if (alive) setCustomer(null); });
    return () => { alive = false; };
  }, [id]);

  const back = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/schedule');
  };

  if (customer === undefined) return <div className="apd-page"><div className="apd-empty">Opening the visit…</div></div>;

  if (customer) {
    return (
      <Suspense fallback={null}>
        <CustomerPopup
          lead={{ object: 'customer', id: customer.id, customer_id: customer.id, display_name: customer.name }}
          leadType="customer"
          initialTab="appointments"
          focusAppointment={id}
          boardStartLabel={boardStartLabel}
          onClose={back}
        />
      </Suspense>
    );
  }

  return (
    <div className="apd-page">
      <button type="button" className="apd-back" onClick={back}>← Back</button>
      <AppointmentRecord id={id} boardStartLabel={boardStartLabel} compact={false} />
    </div>
  );
}
